var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDoctorVirtualCare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 98
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.786.786h96.428v96.428H.786V.786Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    stroke: "#F6914F",
    strokeWidth: 2.93,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.004 22.192h18.15c3.12 0 5.65 2.53 5.65 5.65V75.8c0 3.119-2.53 5.65-5.65 5.65H7.851A5.651 5.651 0 0 1 2.2 75.8V27.842c0-3.12 2.53-5.65 5.65-5.65h24.742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85 63.435V28.402c0-.312.254-.565.566-.565h24.416M65.2 27.835h24.39c.311 0 .564.253.564.565v46.828a.565.565 0 0 1-.565.565H8.416a.565.565 0 0 1-.565-.565v-5.203M54.507 81.445v8.698M43.497 90.143v-8.698M57.702 90.137H40.297a5.085 5.085 0 0 0-5.085 5.085c0 .312.253.565.565.565h26.444a.565.565 0 0 0 .565-.565 5.085 5.085 0 0 0-5.085-5.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.013 40.013v4.025c0 1.348-.86 2.544-2.14 2.974L26.24 51.596a9.41 9.41 0 0 0-6.416 8.92v15.277M55.987 40.034v4.004c0 1.348.86 2.544 2.14 2.974l13.633 4.584a9.41 9.41 0 0 1 6.417 8.92v15.277M32.592 21.415V9.312a7.125 7.125 0 0 1 7.125-7.125h18.571a7.125 7.125 0 0 1 7.125 7.125v12.103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.945 41.594c-9.07-.031-16.353-7.511-16.353-16.572v-5.74c3.272.01 8.188-.404 13.624-2.591a35.657 35.657 0 0 0 6.392-3.362.855.855 0 0 1 1.148.193 14.911 14.911 0 0 0 4.54 3.895 14.966 14.966 0 0 0 7.117 1.865V25.2c0 9.074-7.378 16.425-16.468 16.394ZM58.465 47.128l-8.511 8.503a1.13 1.13 0 0 1-1.598 0l-8.59-8.582M28.381 70.431h-1.32a.973.973 0 0 1-.972-.972V64.81a5.789 5.789 0 0 1 11.578 0v4.649a.973.973 0 0 1-.973.972h-1.32M71.913 65.366a5.068 5.068 0 0 1-5.07 5.065c-2.8 0-5.07-2.268-5.07-5.065a5.068 5.068 0 0 1 5.07-5.066c2.8 0 5.07 2.268 5.07 5.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.842 60.302a12.731 12.731 0 0 0 1.103-5.056 12.734 12.734 0 0 0-1.103-5.299M31.882 59.017c-.351-.959-.74-2.36-.806-4.082-.084-2.228.412-4.01.806-5.09"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.786.786h96.429v96.429H.785z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoctorVirtualCare);
export default __webpack_public_path__ + "static/media/icon_doctor_virtual_care.df3241d6.svg";
export { ForwardRef as ReactComponent };